<template>
  <div>
    <component-loader :active="loading.unfinishedContents"></component-loader>
    <v-data-table
      :headers="headers"
      :items="data"
      :server-items-length="pagination.total"
      :items-per-page="per_page"
      @update:page="changePage"
      :loading="loading.table"
    >
      <template v-slot:item.status="{ item }">
        <template v-if="item.content_type == 'Unit'">
          <v-chip
            class="ma-2"
            :color="chipColors[getStatus(item)]"
            dark
            small
            v-on="on"
          >
            <v-avatar
              v-show="chipIcons[getStatus(item)]"
              left
              :color="chipColors[getStatus(item)]"
            >
              <i :class="chipIcons[getStatus(item)]"></i>
            </v-avatar>
            {{ getStatus(item) }}
          </v-chip>
        </template>
        <template v-else>
          <template v-if="item.status === 1">
            <v-chip class="ma-2 pa-3" color="success" dark small v-on="on">
              <v-avatar left class="success">
                <i class="fas fa-badge-check m-1"></i>
              </v-avatar>
              Completed
            </v-chip>
          </template>
          <template v-else>
            <v-chip
              class="ma-2 p-2"
              color="info"
              dark
              small
              v-on="on"
              @click="unfinishedContents(item)"
            >
              <v-avatar left class="info">
                <i class="fas fa-spinner m-1"></i>
              </v-avatar>
              In Progress
            </v-chip>
          </template>
        </template>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-row>
          <v-col>
            <v-btn icon color="primaryMain" @click="assignContent(item)">
              <v-icon> fas fa-user-plus </v-icon>
              <span v-if="!icon_only">Assign</span>
            </v-btn>
          </v-col>
          <v-col>
            <v-btn icon color="success" @click="shareContent(item)">
              <v-icon> fas fa-share </v-icon>
              <span v-if="!icon_only">Share</span>
            </v-btn>
          </v-col>
          <v-col>
            <v-btn icon color="blue" @click="goToContent(item)">
              <v-icon> fas fa-external-link-alt </v-icon>
              <span v-if="!icon_only">View</span>
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </v-data-table>
    <share-module v-model="share.module.dialog" :module_id="share.module.id">
    </share-module>
    <share-playlist
      v-model="share.playlist.dialog"
      :id="share.playlist.id"
      :playlists="share.playlist.playlist"
    ></share-playlist>
    <share-unit v-model="share.unit.dialog" :id="share.unit.id"></share-unit>
    <assign-module
      v-model="assign.module.dialog"
      :module_id="assign.module.id"
    ></assign-module>
    <assign-playlist
      v-model="assign.playlist.dialog"
      :playlist="{ id: assign.playlist.id }"
    ></assign-playlist>
    <assign-unit
      v-model="assign.unit.dialog"
      :unit_id="assign.unit.id"
    ></assign-unit>
  </div>
</template>

<script>
import assignedAndSharedContents from '@/mixins/assigned-and-shared-contents/assignedAndSharedContents';
import ShareModule from '@/components/client-lms/dialog-box/ShareModule';
import SharePlaylist from '@/components/client-lms/dialog-box/SharePlaylist';
import AssignModule from '@/components/client-lms/dialog-box/AssignModule';
import AssignPlaylist from '@/components/playlist/AssignPlaylist';
import ShareUnit from '@/components/client-lms/dialog-box/ShareUnit';
import AssignUnit from '@/components/client-lms/dialog-box/AssignUnit';
import mixins from '../../mixins';

export default {
  name: 'AssignedByYou',
  components: {
    AssignUnit,
    ShareUnit,
    AssignPlaylist,
    AssignModule,
    SharePlaylist,
    ShareModule,
  },
  props: {
    type: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-  default-prop
      default: ['Playlist', 'Unit', 'Module'],
    },
    per_page: {
      default: 10,
    },
    icon_only: {
      default: false,
    },
  },
  mixins: [assignedAndSharedContents],
  data() {
    return {
      headers: [
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Status',
          value: 'status',
        },
        {
          text: 'Type',
          value: 'content_type',
        },
        {
          text: 'Assignee',
          value: 'assignee.name',
        },
        {
          text: 'Due Date',
          value: 'due_date_formatted',
        },
        {
          text: 'Actions',
          value: 'actions',
        },
      ],
      data: [],
      chipColors: {
        Completed: 'success',
        Played: 'info',
        'Quiz Not Answered': 'warning',
      },
      chipIcons: {
        Rewatched: 'fas fa-clock-rotate-left',
        Completed: 'fas fa-badge-check',
        Played: 'fal fa-tv',
        'Quiz Not Answered': 'fa fa-exclamation',
        Assigned: 'fal fa-users-cog',
        Shared: 'fal fa-share',
      },
      pagination: {
        current_page: 1,
        last_page: 2,
        total: 100,
        per_page: 10,
      },
      loading: {
        table: true,
        unfinishedContents: false,
      },
    };
  },
  created() {
    this.getContents();
  },
  watch: {
    type: {
      immediate: true,
      handler() {
        this.pagination.current_page = 1;
        this.getContents();
      },
    },
  },
  methods: {
    getContents() {
      this.loading.table = true;
      this.$http
        .get('client/lms/assigned-and-shared-contents/assigned-by-you', {
          params: {
            filters: this.type,
            page: this.pagination.current_page,
            per_page: this.per_page,
          },
        })
        .then(({ data }) => {
          this.data = data.data;
          this.pagination.last_page = data.last_page;
          this.pagination.total = data.total;
          this.$nextTick(() => {
            this.loading.table = false;
          });
        });
    },
    changePage(page) {
      this.pagination.current_page = page;
      this.getContents();
    },
    getStatus(item) {
      let unit = item;

      return this.unitStatus(unit);
    },
  },
};
</script>

<style scoped></style>
